import React from 'react'
import Styles from './dashboard.module.css'
import Header from '../components/Header.js'
import Footer from '../components/Footer.js'
import { Outlet } from 'react-router-dom'
import { useIdleTimeout } from '../hooks/useIdleTimeout.js'

function Dashboard() {
    useIdleTimeout();

    return (
        <div className={Styles.body}>
            <Header />
            <div className={Styles.content}>
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}

export default Dashboard
